import React from 'react';

function Heading(props) {
    return (
        <>
        <h1 class="Title mb-4 text-4xl font-extrabold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-6xl dark:text-white">Fash<mark class="px-2 text-white bg-blue-600 rounded dark:bg-blue-500">Intell</mark>.</h1>
        {/* <p class="text-lg font-normal text-gray-500 lg:text-xl dark:text-gray-400">Find your perfect fit.</p> */}
        </>
    );
}

export default Heading;